// ZuschauerPage.jsx — öffentlicher Hallenschirm /zuschauer/:turnierId (Aufgabe 178)
// Vollbild ohne Dashboard drumherum — für Beamer, Hallen-TV oder das Handy.
import React from 'react';
import { useParams } from 'react-router-dom';
import ZuschauerAnsicht from '../components/zuschauer/ZuschauerAnsicht';

export default function ZuschauerPage() {
  const { turnierId } = useParams();
  return <ZuschauerAnsicht turnierId={turnierId} />;
}
